import UserAboutUs from '@/views/user/aboutus'
import UserAccount from '@/views/user/account'
import UserActCategory from '@/views/user/actcategory'
import UserActDetail from '@/views/user/actdetail'
import UserActivity from '@/views/user/activity'
import UserActList from '@/views/user/actlist'
import UserAddress from '@/views/user/address'
import UserAgreement from '@/views/user/agreement'
import UserEventList from '@/views/user/eventlist'
import UserHowToPlay from '@/views/user/howtoplay'
import UserIncome from '@/views/user/income'
import UserIndex from '@/views/user/index'
import UserMint from '@/views/user/mint'
import UserMintConfirm from '@/views/user/mintconfirm'
import UserMintSuccess from '@/views/user/mintsuccess'
import UserNftDetail from '@/views/user/nftdetail'
import UserNftList from '@/views/user/nftlist'
import UserQa from '@/views/user/qa'
import UserQuizDetail from '@/views/user/quizdetail'
import UserSpaceList from '@/views/user/spacelist'
import UserTransferList from '@/views/user/transferlist'
import UserUsdtNo from '@/views/user/usdtno'
import UserUsdtYes from '@/views/user/usdtyes'
import UserVoteList from '@/views/user/votelist'
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// 解决vue路由重复导航错误
// 获取原型对象上的push函数
const originalPush = Router.prototype.push
// 修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

const routes = [
  {
    path: '/',
    name: 'UserIndex',
    component: UserIndex
  },
  {
    path: '/user/aboutus',
    name: 'UserAboutUs',
    component: UserAboutUs
  },
  {
    path: '/user/actlist',
    name: 'UserActList',
    component: UserActList
  },
  {
    path: '/user/actcategory',
    name: 'UserActCategory',
    meta: {
      keepAlive: true
    },
    component: UserActCategory
  },
  {
    path: '/user/agreement',
    name: 'UserAgreement',
    component: UserAgreement
  },
  {
    path: '/user/account',
    name: 'UserAccount',
    meta: {
      keepAlive: true
    },
    component: UserAccount
  },
  {
    path: '/user/nftlist',
    name: 'UserNftList',
    meta: {
      keepAlive: true
    },
    component: UserNftList
  },
  {
    path: '/user/nftdetail',
    name: 'UserNftDetail',
    meta: {
      keepAlive: true
    },
    component: UserNftDetail
  },
  {
    path: '/user/activity',
    name: 'UserActivity',
    component: UserActivity
  },
  {
    path: '/user/actdetail',
    name: 'UserActDetail',
    component: UserActDetail
  },
  {
    path: '/user/income',
    name: 'UserIncome',
    meta: {
      keepAlive: true
    },
    component: UserIncome
  },
  {
    path: '/user/mint',
    name: 'UserMint',
    component: UserMint
  },
  {
    path: '/user/mintconfirm',
    name: 'UserMintConfirm',
    component: UserMintConfirm
  },
  {
    path: '/user/mintsuccess',
    name: 'UserMintSuccess',
    component: UserMintSuccess
  },
  {
    path: '/user/usdtyes',
    name: 'UserUsdtYes',
    component: UserUsdtYes
  },
  {
    path: '/user/usdtno',
    name: 'UserUsdtNo',
    component: UserUsdtNo
  },
  {
    path: '/user/howtoplay',
    name: 'UserHowToPlay',
    component: UserHowToPlay
  },
  {
    path: '/user/transferlist',
    name: 'UserTransferList',
    component: UserTransferList
  },
  {
    path: '/user/qa',
    name: 'UserQa',
    component: UserQa
  },
  {
    path: '/user/quizdetail',
    name: 'UserQuizDetail',
    component: UserQuizDetail
  },
  {
    path: '/user/address',
    name: 'UserAddress',
    component: UserAddress
  },
  {
    path: '/user/votelist',
    name: 'UserVoteList',
    component: UserVoteList
  },
  {
    path: '/user/spacelist',
    name: 'UserSpaceList',
    meta: {
      keepAlive: true
    },
    component: UserSpaceList
  },
  {
    path: '/user/eventlist',
    name: 'UserEventList',
    meta: {
      keepAlive: true
    },
    component: UserEventList
  },
  {
    path: '*',
    name: 'NoPage',
    component: () => import('../views/404.vue')
  }
]

const router = new Router({
  mode: 'history',
  routes
})

// router.beforeEach((to, from, next) => {
//   console.log(from)
//   console.log(to)
//   document.body.scrollTop = 0
//   document.documentElement.scrollTop = 0
//   next()
// })

export default router



// WEBPACK FOOTER //
// ./src/router/user.js